import { render, staticRenderFns } from "./ChatWithCustomers.vue?vue&type=template&id=2594ee6a&"
import script from "./ChatWithCustomers.vue?vue&type=script&lang=js&"
export * from "./ChatWithCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports